export default function ExtraInfo({ info, id }) {

	function sendHelpModalMessage() {
		const data = { title: "Help Modal", content: info}
		parent.postMessage(JSON.stringify({ type: "helpModal", data: data }), "*")
	}

	function toggleInformation(event) {
		event.preventDefault()
		sendHelpModalMessage()
	}

	return (
		<span className="d-inline-block position-relative" style={{ width: "15px" }}>
			<button
				type="button"
				className="border-0 position-absolute"
				style={{backgroundColor: "unset", marginTop: "-30px" }}
			>
				<i
					className="fa-solid fa-circle-info text-warning"
					onClick={toggleInformation}
				/>
			</button>
		</span>
	)
}